import { useLocalizedHref } from "@/libraries/web-framework";

export const JiraSoftwareFreePage = () => {
    // ATLAS-55799 - JSW Find Team
    const queryParameters = new URLSearchParams(location.search) || {};
    const templateId = queryParameters.get("templateId") ?? "";
    const jiraProductTourSignupType =
        queryParameters.get("jiraProductTourSignupType") ?? "";
    const signupPath = useLocalizedHref("/try/cloud/signup");
    const signupParameters = new URLSearchParams({
        bundle: "jira-software",
        edition: "free",
        skipBundles: "true"
    });
    if (templateId) {
        signupParameters.append("templateId", templateId);
    }
    if (jiraProductTourSignupType) {
        signupParameters.append(
            "jiraProductTourSignupType",
            jiraProductTourSignupType
        );
    }
    location.href = `${signupPath}?${signupParameters}`;
    return null;
};
